
const digest = 'eed17ab067d2732374f38819c6b3a4c030b8a501bb53fb879d9763efca6cdb01';
const classes = {"alert":"_alert_9lsrk_1","buttons":"_buttons_9lsrk_6"};
const css = `._alert_9lsrk_1 {
  font-weight: 600;
  margin-bottom: 20px;
}

._buttons_9lsrk_6 {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  margin-top: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  